    // ...existing code...
import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { TaskTimer, TaskTimerHistory } from '../../data-services/task-timer/task-timer.model';
import moment from 'moment-timezone';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { LoggingService } from '../../shared/services/logging';
import { Checkbox } from 'primeng/checkbox';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-task-timer-presenter',
    templateUrl: './task-timer-presenter.component.html',
    styleUrls: ['./task-timer-presenter.component.scss'],
    standalone: false
})
export class TaskTimerPresenterComponent implements OnInit {
    /**
     * Sets the time (hours, minutes, seconds, ms) of a Date object, preserving the original date.
     * @param date The date whose date part to keep
     * @param time The date whose time part to use
     */
    private setTimeOnDate(date: Date, time: Date): Date {
        const newDate = new Date(date);
        newDate.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
        return newDate;
    }
    private ItemsSubject = new ReplaySubject<TaskTimer[]>(1);
    private _items: TaskTimer[];
    @Input() set items(value: TaskTimer[]) {
        if (value && value.length > 0) {
            value = value.map(x => ({
                ...x,
                uniqueid: `${x.empauthid}-${x.timerid}`,
                StatusText:
                    x.Status == 1.4
                        ? 'Status: Partial Validate'
                        : x.Status == 1.5
                        ? 'Status: Validated'
                        : x.Status == 2
                        ? 'Status: Approved'
                        : x.Status == 3
                        ? 'Status: Disapproved'
                        : ''
            }));
            this._items = value;
            this.ItemsSubject.next(value);

            this.timerList = value.filter(x => x.stoptime == null);
            this.timerCbx = this.timerList.some(x => x.timeractive == true);
            if (this.timerList.findIndex(x => x.starttime != null) != -1) {
                this.selectedTask = [];
                this.selectedTask.push(
                    this.timerList.find(x => x.starttime != null)
                );
                this.stopTimerDisabled = false;
                this.startTimerDisabled = true;
            }
            this.timerList = this.timerList.map(x => ({
                ...x,
                starttime:
                    x.starttime != null
                        ? moment(new Date(x.starttime)).format(
                              'MM/DD/YYYY HH:mm:ss'
                          )
                        : null
            }));
            this.tasksSelectItem = this.timerList.map(x => ({
                label: x.taskdisplay,
                value: x.empauthid
            }));
            this.history = value.filter(x => x.stoptime != null);
            this.history = this.history.sort((a, b) => {
                return (
                    new Date(b.stoptime).getTime() -
                    new Date(a.stoptime).getTime()
                );
            });
            this.history = this.history.map(x => ({
                ...x,
                starttime:
                    x.starttime != null
                        ? moment(x.starttime).format('MM/DD/YYYY HH:mm:ss')
                        : null,
                stoptime:
                    x.stoptime != null
                        ? moment(x.stoptime).format('MM/DD/YYYY HH:mm:ss')
                        : null
            }));
        }
    }
    get items(): TaskTimer[] {
        return this._items;
    }

    private TimerHistorySubject = new ReplaySubject<TaskTimerHistory[]>(1);
    private _timerhistory: TaskTimerHistory[];
    @Input() set timerHistory(value: TaskTimerHistory[]) {
        if (value && value.length > 0) {
            value = value.map(x => {
                let readonly = false;
                if (x.stoptime && this.currentMonthStart && this.currentMonthEnd) {
                    const stopTimeVal = new Date(x.stoptime).getTime();
                    readonly = (stopTimeVal < this.currentMonthStart.getTime() || stopTimeVal > this.currentMonthEnd.getTime());
                }
                return {
                    ...x,
                    readonly,
                    uniqueid: `${x.empauthid}-${x.timerid}`,
                    StatusText:
                        x.status == 1.4
                            ? 'Status: Partial Validate'
                            : x.status == 1.5
                            ? 'Status: Validated'
                            : x.status == 2
                            ? 'Status: Approved'
                            : x.status == 3
                            ? 'Status: Disapproved'
                            : ''
                };
            });
            value = value.sort((a, b) => {
                const aTime = a.stoptime ? new Date(a.stoptime).getTime() : 0;
                const bTime = b.stoptime ? new Date(b.stoptime).getTime() : 0;
                return bTime - aTime;
            });
            this._timerhistory = value;
            this.TimerHistorySubject.next(value);
            this.TimerHistoryTable.value = value;
        }
    }
    get timerHistory(): TaskTimerHistory[] {
        return this._timerhistory;
    }

    private UserInfoSubject = new ReplaySubject<IUserInfo>(1);
    private _userinfo: IUserInfo;
    @Input() set userInfo (value: IUserInfo) {
        if (value) {
            this._userinfo = value;
            this.UserInfoSubject.next(value);

            this.currentMonthStart = new Date(value.UserEntryStartDate);
            this.currentMonthEnd = new Date(value.UserEntryEndDate);
            this.dateRange = [this.currentMonthStart, this.currentMonthEnd];
        }
    }
    get userInfo(): IUserInfo {
        return this._userinfo;
    }


    @ViewChild('TimerTable') TimerTable: Table;
    @ViewChild('TimerHistoryTable') TimerHistoryTable: Table;
    @ViewChild('ShowHistoryCbx') ShowHistoryCbx: Checkbox;

    @Output() StartTimer = new ReplaySubject<any>(1);
    @Output() StopTimer = new ReplaySubject<any>(1);
    @Output() LoadTimerHistory = new ReplaySubject<any>(1);
    @Output() UpdateTimerHistory = new ReplaySubject<any>(1);

    tasksSelectItem: SelectItem[];

    selectedTask: TaskTimer[];

    history: TaskTimer[];
    timerList: TaskTimer[];

    calculatedTime = null;

    timeZone: any;

    startTimerDisabled = true;
    stopTimerDisabled = true;

    statusText: string;

    editing?: TaskTimer;
    clonedTaskTimer: { [i: string]: TaskTimer } = {};

    showHistory = false;

    startDate: Date;
    endDate: Date;

    histStartTime: Date;
    histEndTime: Date;

    errorOnUpdate = false;
    uiErrorMessage: string;

    commentOnUpdate = false;
    comment: string;

    rowData: TaskTimerHistory;

    dateRange: Date[];
    currentMonthStart: Date;
    currentMonthEnd: Date;

    showErrorDialog = false;
    showTimerOverlapDialog = false;

    timerCbx = false;

    constructor(private log: LoggingService) {}

    ngOnInit(): void {
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    showHistoryCheckboxChanged($event) {
        this.TimerHistoryTable.clear();
        if ($event.checked == true) {
            this.historyDatesSelected(this.currentMonthStart);
            this.historyDatesSelected(this.currentMonthEnd);
            //this.TimerHistoryTable.value = this.timerHistory;
        } else {
            this.TimerHistoryTable.value = this.history;
        }
    }

    rowSelected(event) {
        this.selectedTask[0] = event.data;
        this.startTimerDisabled = false;
        this.stopTimerDisabled = true;
    }
    rowUnselected(event) {
        this.selectedTask = [];
        this.startTimerDisabled = true;
        this.stopTimerDisabled = true;
    }

    startTimer() {
        //this.ShowHistoryCbx.disabled = true;
        var splitarr = moment.tz(moment(), this.timeZone).format().split('-');
        var starttime = `${splitarr[0]}-${splitarr[1]}-${splitarr[2]}`;
        this.selectedTask[0] = {
            ...this.selectedTask[0],
            timersource: 'Web',
            timeractive: true,
            starttime: starttime
        };
        const jsonstr = JSON.stringify(this.selectedTask[0]);
        this.StartTimer.next(jsonstr);
        this.selectedTask = [];
        this.startTimerDisabled = true;
        this.stopTimerDisabled = false;
    }
    stopTimer() {
        //this.ShowHistoryCbx.disabled = false;
        var splitarr = moment.tz(moment(), this.timeZone).format().split('-');
        var stoptime = `${splitarr[0]}-${splitarr[1]}-${splitarr[2]}`;
        this.selectedTask[0] = {
            ...this.selectedTask[0],
            timersource: 'Web',
            timeractive: false,
            stoptime: stoptime
        };
        const jsonstr = JSON.stringify(this.selectedTask[0]);
        this.StopTimer.next(jsonstr);
        this.selectedTask = [];
        this.startTimerDisabled = true;
        this.stopTimerDisabled = true;
    }
    viewCalculatedTimeClicked(rowData) {
        var currentTime = new Date().getTime();
        var startTime = new Date(rowData.starttime).getTime();
        var diff = currentTime - startTime;
        var msec = diff;
        var hh = Math.floor(msec / 1000 / 60 / 60);
        msec -= hh * 1000 * 60 * 60;
        var mm = Math.floor(msec / 1000 / 60);
        msec -= mm * 1000 * 60;
        var ss = Math.floor(msec / 1000);
        msec -= ss * 1000;

        this.calculatedTime = `${hh} hr ${mm} min ${ss} sec`;

        const itemIndex = this.timerList.findIndex(
            x => x.starttime == rowData.starttime
        );

        this.timerList[itemIndex] = {
            ...this.timerList[itemIndex],
            CalculatedTime: this.calculatedTime
        };

        setTimeout(() => {
            this.calculatedTime = null;
        }, 5000);
    }

    historyDatesSelected($event) {
        this.timerHistory = [];
        if (moment($event).isValid()) {
            if (this.startDate != null) {
                if (this.startDate.getTime() > new Date($event).getTime()) {
                    this.startDate = $event;
                } else {
                    this.endDate = $event;
                }
            } else {
                this.startDate = $event;
            }
            if (this.startDate != null && this.endDate != null) {
                this.LoadTimerHistory.next({StartDate: this.startDate, EndDate: this.endDate});
            }
        }
        console.log($event);
    }

    filterTable($event, filterType) {
        // use this for all table filters
        if (filterType == 'task') {
            this.TimerTable.filter($event.value, 'empauthid', 'in');
        }
    }

    onEditInit($event: { data: TaskTimerHistory }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: TaskTimerHistory) {
        this.histStartTime = new Date(rowData.starttime);
        this.histEndTime = new Date(rowData.stoptime);
        //new Date(moment(rowData.starttime).hours(), moment(rowData.starttime).minutes(), moment(rowData.starttime).seconds());
        this.clonedTaskTimer[rowData.uniqueid] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: TaskTimerHistory) {
        let timerOverlap = false;
        let hoursTotalForDay = 0;

        // Update histStartTime and histEndTime, preserving date, updating time
        if (rowData && rowData.starttime && this.histStartTime) {
            this.histStartTime = this.setTimeOnDate(new Date(rowData.starttime), this.histStartTime);
        }
        if (rowData && rowData.stoptime && this.histEndTime) {
            this.histEndTime = this.setTimeOnDate(new Date(rowData.stoptime), this.histEndTime);
        }

        // Only proceed if both histStartTime and histEndTime are defined
        if (!this.histStartTime || !this.histEndTime) {
            this.uiErrorMessage = 'Start time or end time is missing.';
            this.showErrorDialog = true;
            return;
        }

        // If start > end, set start = end (never allow start to exceed end)
        if (this.histStartTime.getTime() > this.histEndTime.getTime()) {
            // If the start time is after the end time, set start time to end time
            this.histStartTime = new Date(this.histEndTime);
        }

        // If end and start are on different days, allow start to be updated into the same day as end
        // (no restriction needed, as above logic already prevents start > end)

        const calcHrsForRow = Math.floor((this.histEndTime.getTime() - this.histStartTime.getTime()) / 1000 / 60 / 60);
        this.timerHistory.forEach(timer => {
            if (timer.workdate == rowData.workdate && rowData.timerid != timer.timerid) {
                hoursTotalForDay += +timer.calculatedhours;
                if ((this.histStartTime.getTime() >= new Date(timer.starttime).getTime() && this.histStartTime.getTime() <= new Date(timer.stoptime).getTime()) ||
                    (this.histEndTime.getTime() >= new Date(timer.starttime).getTime() && this.histEndTime.getTime() <= new Date(timer.stoptime).getTime())) {
                    timerOverlap = true;
                    return;
                }
            }
        });

        if ((hoursTotalForDay + calcHrsForRow) < 24 && timerOverlap == false) {
            this.showCommentDialog();
        } else {
            if ((hoursTotalForDay + calcHrsForRow) > 24) {
                this.showErrorDialog = true;
            }
            if (timerOverlap) {
                this.showTimerOverlapDialog = true;
                timerOverlap = false;
            }
        }

        this.rowData = rowData;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: TaskTimerHistory) {
        // const index = this.tableItemSource.findIndex(
        //     x => x.uniqueid === item.uniqueid
        // );
        // if (index >= 0) {
        //     this.tableItemSource.splice(
        //         index,
        //         1,
        //         this.clonedTaskTimer[item.uniqueid]
        //     );
        // }
        // this.tableItemSource = [...this.tableItemSource];

        delete this.clonedTaskTimer[item.uniqueid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    showCommentDialog() {
        this.commentOnUpdate = true;
    }
    addComment() {
        var splitstart = moment(this.histStartTime).format().split('-');
        var start = `${splitstart[0]}-${splitstart[1]}-${splitstart[2]}`;
        var splitstop = moment(this.histEndTime).format().split('-');
        var stop = `${splitstop[0]}-${splitstop[1]}-${splitstop[2]}`;
        this.rowData = {
            ...this.rowData,
            timecomment: this.comment,
            starttime: start,
            stoptime: stop,
            HistoryStart: moment(this.startDate).format('MM/DD/YYYY'),
            HistoryEnd: moment(this.endDate).format('MM/DD/YYYY')
        };

        this.UpdateTimerHistory.next(this.rowData);
        delete this.clonedTaskTimer[this.rowData.uniqueid];
        delete this.editing;
        this.commentOnUpdate = false;
    }
}
